import type { FC } from "react";

import type { DefaultInputFieldProps, IItem } from "@similarweb/pro-logic-components";

import { multiIncludeExcludeType } from "app/components/multi-include-exclude-filter/consts";
import { TextFieldComponentWrapper } from "app/components/multi-include-exclude-filter/TextFieldComponent";
import { getParsedKeywords } from "app/components/multi-include-exclude-filter/utils";
import { translate } from "app/filters/i18nFilter";
import { AutocompleteKeywords } from "pro-features/components/AutocompleteKeywords/AutocompleteKeywords";
import { allTrackers } from "app/services/track/track";

const trackNewRule = (newValue: IItem[]) => {
    const keyword = newValue.map((item) => item.text).join(",");

    allTrackers.dispatchTrackEvent("Drop Down", "click", `keyword added/${keyword}/topic`);
};

export const TopicAutocomplete: FC<DefaultInputFieldProps> = (props) => {
    const { rule, maxItemsPerRule, textBoxWidth, onAddNewRule } = props;
    const isDisabled = rule.items?.length >= maxItemsPerRule;

    const handleOnAddNewRule = (value: string) => {
        const newValue: IItem[] = getParsedKeywords(value, multiIncludeExcludeType.TOPIC);
        onAddNewRule(newValue);
    };

    const onAutocompleteItemClick = (value: string) => {
        handleOnAddNewRule(value);
    };

    return (
        <TextFieldComponentWrapper width={textBoxWidth}>
            <AutocompleteKeywords
                onClick={onAutocompleteItemClick}
                numOfQueryItems={9}
                autocompleteProps={{
                    placeholder: translate("multi.include.exclude.topic.placeholder"),
                    disabled: isDisabled,
                    resetValueOnSelect: true,
                }}
                emptyState={{
                    emptyStateKeywords: [],
                    emptyStateTitle: translate("multi.include.exclude.keywords.placeholder.keywords"),
                }}
                exclude={rule?.items?.length ? rule.items?.map((item) => item.text) : []}
                selectedValue=""
                onValueChange={() => {}}
            />
        </TextFieldComponentWrapper>
    );
};
